import { jsx as _jsx } from "react/jsx-runtime";
import { urlTransform } from "../../../hooks/ImageHook";
const CategoryImage = ({ image, hide }) => {
    return (_jsx("div", { className: "categories__image", children: hide ? (_jsx("img", { src: urlTransform(image, 200), alt: "", className: "faded_blocked" })) : (_jsx("img", { src: urlTransform(image, 200), alt: "" })) }));
};
export default CategoryImage;
